import React, { PropTypes } from 'react';
import GoogleMap from 'google-map-react';
import { isEmpty } from 'lodash';
import { drawPoints, drawRects } from '../../businessLogic/map';

export default class MapContent extends React.Component {

	constructor(props) {
		super(props);
		this.state = { mapLoaded: false, showTooltip: false, x: 0, y: 0 };
	}

	componentDidUpdate(prevProps, prevState) {

		const { locations, getGeom } = this.props;

		if ( !this.state.mapLoaded ) return;
		if ( isEmpty(this.props.locations) ) return;

		const map = this.google.map;

		// Draw points
		drawPoints(locations.points, map);

		// Draw rects
		drawRects(locations.rects, map);

		// Draw geoms
		locations.sectors.map((s) => getGeom(s.value, map, true, "locations"));
		locations.localities.map((s) => getGeom(s.value, map, true, "locations"));
		locations.samplingPoints.map((s) => getGeom(s.value, map, true, "locations"));		
	}

	getStyle() {
		const { width, height } = this.props;
		return { 
			width: parseFloat(width.substr(0, width.length - 2)) - 40 + "px",
			height: parseFloat(height.substr(0, height.length - 2)) - 42 + "px"
		};
	}

	render () {
		return (
			<div style={this.getStyle()}>	
				<GoogleMap
					bootstrapURLKeys={
					{
						key: "AIzaSyA7pbCrlAlFUZLlWPSriQWUIYUk8__7JLM",
						language: 'pt-BR'
					}
					}												
					center={{lat: -20.049293182101255, lng: -42.82365408697386}}
					options={{streetViewControl: true, mapTypeId: 'satellite'}}
					defaultZoom={7}
					yesIWantToUseGoogleMapApiInternals
					onGoogleApiLoaded={(google) => {							
						this.google = google;
						this.setState({mapLoaded: true});							
					}}							
				/>
			</div>						
		);
	}
}

MapContent.propTypes = {
	getGeom: PropTypes.func.isRequired,
	width: PropTypes.string.isRequired,
	height: PropTypes.string.isRequired,
	locations: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/MapContent.js